import { Button, Spin, Modal, Image } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useState, useCallback } from 'react';
import { useApi } from '@hooks/useApi';
const MeterReadDetailsFileCell = ({ id, data, styles }) => {
  const { fetchScreenshotDownloadUrl } = useApi();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const year = data?.month_year?.split('-')[0];
  const month = data?.month_year?.split('-')[1];

  const handleDownload = useCallback(async () => {
    if (!year || !month) return;
    setLoading(true);
    try {
      const url = await fetchScreenshotDownloadUrl(id, Number(year), Number(month));
      if (url) {
        setImageUrl(url);
        setIsModalOpen(true);
      }
    } catch {
      // no file found
    } finally {
      setLoading(false);
    }
  }, [fetchScreenshotDownloadUrl, id, year, month]);

  if (!data?.value) return <>--</>;

  return (
    <>
      <Button
        type="link"
        icon={loading ? <Spin size="small" /> : <EyeOutlined />}
        className={styles.downloadButton}
        onClick={handleDownload}
        disabled={loading}
        data-testid="screenshot-view-button"
      >
        {loading ? 'Loading...' : 'View'}
      </Button>
      <Modal
        open={isModalOpen}
        onCancel={() => { setIsModalOpen(false); setImageUrl(null); }}
        footer={[<Button key="close" onClick={() => { setIsModalOpen(false); setImageUrl(null); }} data-testid="modal-close-button">Close</Button>]}
        width={800}
        centered
        wrapProps={{ 'data-testid': 'screenshot-modal' }}
      >
        {imageUrl && <Image src={imageUrl} alt="Screenshot" style={{ width: '100%' }} preview={false} data-testid="screenshot-image" />}
      </Modal>
    </>
  );
};

export default MeterReadDetailsFileCell;
